import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiClock, FiUserX, FiAlertCircle } = FiIcons;

const ProblemSection = () => {
  const problems = [
    {
      icon: FiClock,
      title: 'Recruiters',
      description: 'Manual sifting through hundreds of resumes eats days of valuable time'
    },
    {
      icon: FiUserX,
      title: 'Candidates',
      description: 'Poor communication and long wait times lead to high dropout rates'
    },
    {
      icon: FiAlertCircle,
      title: 'Hiring Panels',
      description: 'Inconsistent feedback and subjective decisions create bias and delays'
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="font-display font-bold text-3xl lg:text-5xl text-slate-900 mb-6">
            Hiring is slow, expensive and noisy
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Traditional recruitment processes create bottlenecks that hurt everyone involved
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {problems.map((problem, index) => (
            <motion.div
              key={index}
              className="bg-red-50 border border-red-100 rounded-2xl p-8 text-center"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <SafeIcon icon={problem.icon} className="w-8 h-8 text-red-600" />
              </div>
              <h3 className="font-semibold text-xl text-slate-900 mb-4">
                {problem.title}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {problem.description}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <div className="inline-block bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-8 py-4 rounded-full font-semibold text-lg shadow-elegant">
            Here's how Instashortlist fixes that →
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ProblemSection;